import React from "react";
import {
    Container,
    TextNameContainer,
    TextName,
    TextValue,
    Row,

    LabelContainer
} from "./styled";
import { theme } from "../../../ui/theme-color";

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


export default function TotalViewsCard({ data }) {


    function formatNumber(num) {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
        }

        if (num >= 1_000) {
            return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
        }

        return num?.toString();
    }

    const allMetrics = [
        {
            name: 'Visualizações Totais',
            value: formatNumber(data?.[0]?.views),
        },
        {
            name: 'ER',
            value: `${(data?.[0]?.engagement_rate)?.toFixed(2)}%`,
        },
        {
            name: 'Engajamento Total',
            value: formatNumber(data?.[0]?.interactions),
        },
        {
            name: 'Total de Curtidas',
            value: formatNumber(data?.[0]?.likes),
        },
        {
            name: 'Comentários Totais',
            value: formatNumber(data?.[0]?.comments),
        },
        {
            name: 'Compartilhamentos',
            value: formatNumber(data?.[0]?.shares),
        },
        {
            name: 'Est. Alcance',
            value: formatNumber(data?.[0]?.reach),
        },
    ]

    return (
        <Container>
            {allMetrics.map((item) =>
                <Row>
                    <TextNameContainer>
                        <TextName>{item.name}</TextName>
                        {/* <Label text="Pode melhorar" /> */}
                        <HelpOutlineIcon fontSize="10px" color={theme.palette.colors.text} />
                    </TextNameContainer>
                    <TextValue>{item.value}</TextValue>
                </Row>)}
        </Container>
    );
}

function Label({ text }) {
    return (
        <LabelContainer>
            {text}
        </LabelContainer>
    );
}